// extracted by mini-css-extract-plugin
module.exports = {"serviceInfo__slider":"_2j7yeMQ2O5mg","single":"_2CpnXzIkuP03","single_cancel":"_2pA20HbKiwMx","clear":"_385UvpRNTJAL","clearContainer":"_3SO73w8NSDri"};